var c = Object.defineProperty;
var p = (o, t, e) => t in o ? c(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var s = (o, t, e) => p(o, typeof t != "symbol" ? t + "" : t, e);
import { action as d, flow as l, makeObservable as I, observable as f } from "mobx";
import { h as b } from "./oauth-callback-D1dy1GrA.js";
import { e as y } from "./tokens-C4KyVSzL.js";
var A = Object.defineProperty, C = Object.getOwnPropertyDescriptor, i = (o, t, e, u) => {
  for (var r = u > 1 ? void 0 : u ? C(t, e) : t, h = o.length - 1, a; h >= 0; h--)
    (a = o[h]) && (r = (u ? a(t, e, r) : a(r)) || r);
  return u && r && A(t, e, r), r;
};
class n {
  constructor(t) {
    s(this, "isAuthenticated", !1);
    s(this, "userInfo", null);
    s(this, "authClient");
    s(this, "loadUserInfo");
    s(this, "onLogoutError");
    this.authClient = t.authClient, this.loadUserInfo = t.loadUserInfo, this.onLogoutError = t.onLogoutError, I(this);
  }
  setUserInfo(t) {
    this.userInfo = t;
  }
  *init() {
    if (b() || y()) {
      const e = yield this.authClient.initWithCheckSso();
      this.isAuthenticated = e || !1;
    } else
      yield this.authClient.init(), this.isAuthenticated = !0;
    if (!this.isAuthenticated)
      return;
    const t = yield this.loadUserInfo();
    this.userInfo = t;
  }
  *logout() {
    var t;
    try {
      yield this.authClient.logout();
    } catch (e) {
      this.userInfo = null, this.isAuthenticated = !1, (t = this.onLogoutError) == null || t.call(this, e);
    }
  }
}
i([
  f
], n.prototype, "isAuthenticated", 2);
i([
  f
], n.prototype, "userInfo", 2);
i([
  d.bound
], n.prototype, "setUserInfo", 1);
i([
  l.bound
], n.prototype, "init", 1);
i([
  l.bound
], n.prototype, "logout", 1);
export {
  n as AuthStore
};
//# sourceMappingURL=mobx.es.js.map
